import lock from '@client/assets/icons/lock.svg';
import { useTranslation } from 'react-i18next';
import { DisclaimerText, LockIcon, LockSpacer, DisclaimerStack } from './disclaimer.style';

export const Disclaimer = (): JSX.Element => {
  const { t } = useTranslation('connect', { keyPrefix: 'components.disclaimer' });

  return (
    <DisclaimerStack>
      <LockSpacer>
        <LockIcon src={lock} aria-hidden />
      </LockSpacer>
      <DisclaimerText>{t('text')}</DisclaimerText>
    </DisclaimerStack>
  );
};
